// extracted by mini-css-extract-plugin
export default {"contentContainer":"about_contentContainer__v0Ebk","pageTitle":"about_pageTitle__6umVm","articleIntro":"about_articleIntro__pxC7f","bulletedList":"about_bulletedList__iYDw3"};